import UserIcon from "../assets/images/icons/user.png";
import { LineChartOutlined, LogoutOutlined, MailOutlined,MenuUnfoldOutlined,MenuFoldOutlined,TagOutlined, CommentOutlined, PushpinOutlined } from "@ant-design/icons";
import Dropdown from "antd/es/dropdown/dropdown";
import Modal from "antd/es/modal/Modal";
import { Button, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import ChatAIIcon from "../assets/images/icons/chat_AI_icon.svg";
import ChatAIIconActive from "../assets/images/icons/chat_AI_icon_active.svg";
import ReportAnalyserIcon from "../assets/images/icons/report_analyser.svg";
import ReportAnalyserActiveIcon from "../assets/images/icons/report_analyser_active.svg";
import DocumentGptIcon from "../assets/images/icons/document_gpt_active.svg";
import SummarizerIcon from "../assets/images/icons/summarizer.svg";
import DocumentGPTIcom from "../assets/images/icons/document_gpt_active.svg";
import Logo from "../assets/images/icons/GalaxyLogo.svg";
import HDFCLogo from "../assets/images/icons/HDFC_logo.svg";
import { useLocation } from "react-router-dom";
import { Auth } from "../libs/utilities/helpers/Auth";
import Qlik2 from '../assets/images/icons/qlik2.png';
import { logout } from '../apis/AuthAPI'
import { useDispatch } from "react-redux";




export const getAppMenu = (userAccessibility) => {
    const staticMenu = [
        {
            title: "Chat AI",
            route: "chat-ai",
            info: "A generative AI based chatbot to process human-like conversations",
            icon: ChatAIIcon,
            activeIcon: ChatAIIconActive,
            width: 141
        },
        {
            title: "Report Analyser",
            info: "A  Gen AI tool that allows users to ask questions about their documents.",
            icon: SummarizerIcon,
            activeIcon: DocumentGPTIcom,
            route: "report-analyser",
            width: 225
        },
        {
            title: "Report Generator",
            info: "Generates financial report about a company basis DRHP prospectus, annual reports, financial numbers",
            icon: ReportAnalyserIcon,
            activeIcon: ReportAnalyserActiveIcon,
            route: "report-generator",
            width: 208
        },

        {
            title: "PCVC",
            info: "An AI generated diarized transcripts of PCVC audit videos/calls",
            icon: ReportAnalyserIcon,
            activeIcon: ReportAnalyserActiveIcon,
            route: "pcvc",
            width: 128.469
        },
        {
            title: "Complaint Analyser",
            info: "A Generative AI service to generate concise summaries for complaints RCA about customer interactions across touchpoints and systems",
            icon: SummarizerIcon,
            activeIcon: DocumentGPTIcom,
            route: "complaint-analyser",
            width: 222.731
        },
        {
            title: "Pre-claims Assistant",
            info: "Generation of case gist basis customer details for suspected early claims cases",
            icon: SummarizerIcon,
            activeIcon: DocumentGPTIcom,
            route: "pre-claims",
            width: 216
        },
        {
            title: "Call Repository",
            info: "A service to upload call recordings and xlsx files  ",
            icon: ReportAnalyserIcon,
            activeIcon: ReportAnalyserActiveIcon,
            route: "call-repository",
            width: 200
        },
        // {
        //     title: "Marketing",
        //     info: "Use Gen AI to boost SMS/email campaign engagement and response.",
        //     icon: ReportAnalyserIcon,
        //     activeIcon: ReportAnalyserActiveIcon,
        //     route: "marketing",
        //     width: 200

        // },
        {
            title: "Marketing",
            info: "Use Gen AI to boost SMS/email campaign engagement and response.",
            icon: ReportAnalyserIcon,
            activeIcon: ReportAnalyserActiveIcon,
            route: "marketing",
            width: 200,
            children: [
                {
                    title: "Generate SMS",
                    route: "marketing",
                    info: "Generate SMS content",
                    icon: <CommentOutlined />,  
                    activeIcon: <CommentOutlined />,  
                    width: 150,
                },
                {
                    title: "Generate Subject Line",
                    route: "marketing",
                    info: "Generate email subject lines",
                    icon: <TagOutlined />,
                    activeIcon: <TagOutlined />,
                    width: 180,
                },
                {
                    title: "Generate Email",
                    route: "marketing",
                    info: "Generate full email content",
                    icon: <MailOutlined />,
                    activeIcon: <MailOutlined />,
                    width: 150,
                },
                {
                    title: "Generate CTAs",
                    route: "marketing",
                    info: "Generate call-to-action lines",
                    icon: <PushpinOutlined />,
                    activeIcon: <PushpinOutlined />,
                    width: 130,
                },
            ],
        },
        {
            title: "Summary Sheet",
            info: "A tool to capture all customer information for complaint resolution.",
            icon: ReportAnalyserIcon,
            activeIcon: ReportAnalyserActiveIcon,
            route: "summary-sheet",
            width: 200
        },
        {
            title: "Cancellation Grid",
            info: "An AI to provide automated decision for missale complaints.",
            icon: ReportAnalyserIcon,
            activeIcon: ReportAnalyserActiveIcon,
            route: "cancellation-grid",
            width: 200
        },
        {
            title: "Compliance GPT",
            info: "Assists in answering queries related to IRDAI circulars or notifications",
            icon: ReportAnalyserIcon,
            activeIcon: ReportAnalyserActiveIcon,
            route: "compliance-gpt",
            width: 200
        },
        {
            title: "Case Start",
            info: "Generation of case gist basis customer details",
            icon: ReportAnalyserIcon,
            activeIcon: ReportAnalyserActiveIcon,
            route: "case-start",
            width: 200
        },
        {
            title: "AI MBR",
            info: "A generative AI tool that allow users to ask questions about their documents.",
            icon: SummarizerIcon,
            activeIcon: DocumentGPTIcom,
            route: "ai-mbr",
            width: 191,
        },
        {
            title: "Call Summarizer",
            info: "To summarise customer calls on request basis to reduce repeat and identify potential complaints",
            icon: ReportAnalyserIcon,
            activeIcon: ReportAnalyserActiveIcon,
            route: "call-summarizer",
            width: 200
        },
        {
            title: "Legal Case Analyser",
            info: "AI service for analyzing legal complaints and providing results along with probability assessments.",
            icon: ReportAnalyserIcon,
            activeIcon: ReportAnalyserActiveIcon,
            route: "legal-case-analyser",
            width: 200
        },
        {
            title: "Financial Fraud",
            info: "Agentic AI for financial fraud identification",
            icon: ReportAnalyserIcon,
            activeIcon: ReportAnalyserActiveIcon,
            route: "financial-fraud",
            width: 200
        }

    ];
    const dynamicGptServices = userAccessibility
        .filter(service => service.type === "gpt")
        .map(service => ({
            title: service.title,
            route: service.service,
            info: service.info,
            icon: SummarizerIcon,
            activeIcon: DocumentGptIcon,
            width: 200,
        }));

    return [...staticMenu, ...dynamicGptServices];
};

const CustomHeader = ({ collapsed, setCollapsed }) => {
    const DASHBOARD_URL = process.env.REACT_APP_DASHBOARD_URL;
    const location = useLocation();
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [accessibleMenu, setAccessibleMenu] = useState([]);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [logoutLoading, setLogoutLoading]=useState(false)
    const user = Auth.getUser();
    const dispatch = useDispatch();


    const items = [
        {
            label: <a onClick={() => setOpen(true)}>Logout</a>,
            key: '1',
            icon: <LogoutOutlined />,
            danger: true,

        },
    ];

    useEffect(() => {
        let accessibility = user?.accessibility?.filter(item => item.status);
        if (accessibility) {
            let menus = getAppMenu(accessibility).filter(item => accessibility.some(menu => menu.service === item.route));
            menus.sort((a, b) => {
                const priorityA = accessibility.find(item => item.service === a.route);
                const priorityB = accessibility.find(item => item.service === b.route);
                if (priorityA && priorityB) {
                    return priorityA.index - priorityB.index;
                } else if (priorityA) {
                    return -1;
                } else if (priorityB) {
                    return 1;
                }
                return 0;
            });
            setAccessibleMenu(menus);
        }

        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };

    }, [])

    const visibleMenuItems = accessibleMenu.filter((item, index) => {
        const totalItemWidth = accessibleMenu
            .slice(0, index + 1)
            .reduce((acc, curr) => acc + curr.width, 0);
        return totalItemWidth + (collapsed ? 200 : 408) <= windowWidth;
    });

    const handleLogout = () => {
        localStorage.clear();
        sessionStorage.clear();
        const logoutUrl = `https://login.microsoftonline.com/${process.env.REACT_APP_MICROSOFT_TENANT_ID}/oauth2/v2.0/logout?post_logout_redirect_uri=${process.env.REACT_APP_BASE_URL}`;
        window.location.href = logoutUrl;
    };

    // const handleLogout = async () => {
    //     try {
    //         setLogoutLoading(true);
    //       const response = await dispatch(logout());
    //       if (response.payload?.statusCode === 201) {
    //         navigate("/login");
    //       } else {
    //       }
    //     } catch (error) {
    //       console.error("Logout failed", error);
    //     }
    //   };

    return (
        <>
            {/* <header> */}
            <div className="header">
                <div className="header-text">
                    <div className="heading" style={{ gap: "15px" }}>
                    <div className="hamburgr-option" style={{color:"black"}} onClick={() => setCollapsed(!collapsed)}>
{collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                    </div>
                        <img src={HDFCLogo} style={{height: '40px'}} />
                        <img src={Logo} style={{ marginTop: "-2px", height: "40px" }} />
                    </div>
                </div>
                <div className="right-nav">
                    {location.pathname === '/ai-mbr' && <a href="https://qliksense.hdfclife.com/" target="_blank">
                        <Tooltip title="Visit Qlik Sense">
                            <img src={Qlik2} alt="" width={60} style={{ marginTop: "5px" }} />
                        </Tooltip>
                    </a>}
                    <a href={DASHBOARD_URL} target="_blank"><LineChartOutlined style={{ fontSize: "20px", cursor: "pointer" }} /></a>
                    <div className="user" >
                        <Dropdown menu={{ items }} trigger={["click"]}>
                            <img src={UserIcon} alt="usericon" style={{ cursor: "pointer", height: "37px" }} />
                        </Dropdown>
                    </div>
                </div>
            </div>
            <Modal
                title="Are you sure you want to logout?"
                open={open}
                onCancel={() => setOpen(false)}
                footer={[
                    <Button key="okay" type="text" onClick={() => setOpen(false)}>
                        Cancel
                    </Button>,
                    <Button key="okay" type="primary" loading={logoutLoading} onClick={handleLogout}>
                        Okay
                    </Button>,
                ]}
            >
            </Modal>
        </>
    )
}

export default CustomHeader;